<template>
    <div>
        <button
            type="button"
            class="button button--icon button--darkgray"
            @click="showModal = true"
        >
            <IconBin class="button__icon" />
            <span v-t="'misc.delete'" />
        </button>

        <portal to="modals">
            <ConfirmModal
                v-if="showModal"
                name="users-delete"
                :title="$t('crm.users.delete.title')"
                :ok-label="$t('misc.delete')"
                @confirmed="confirmed"
                @canceled="showModal = false"
            >
                <template #content>
                    <div class="user-delete__content">
                        <p v-text="$t('crm.users.delete.content')"></p>
                    </div>
                </template>
            </ConfirmModal>
        </portal>
    </div>
</template>

<script>
import { ConfirmModal } from '@speechki-frontend/shared/ui/modals';
import { IconBin } from '@speechki-frontend/shared/ui/icons';

export default {
    name: 'UsersDelete',
    components: {
        ConfirmModal,
        IconBin,
    },
    data() {
        return {
            showModal: false,
        };
    },
    methods: {
        confirmed() {
            this.showModal = false;
            this.$emit('confirmed');
        },
    },
};
</script>

<style src="./UsersDelete.scss" lang="scss"></style>
